import CLPViewState, {
    LabelApplyMethod,
} from 'owa-mail-protection-types/lib/schema/clp/CLPViewState';
import CLPLabel from 'owa-mail-protection-types/lib/schema/CLPLabel';

// When the following condition fits automatic label should be applied and infobar should show.
// 1. When the automatic label exists
// 2. When the currently label is not manually set.
// 3. When there is no label manually set or the currently set label has lower encryption level than auto label.
export function shouldApplyAutomaticLabel(clpViewState: CLPViewState, automaticLabel: CLPLabel) {
    if (clpViewState.labelApplyMethod == LabelApplyMethod.Manual || !automaticLabel) {
        return false;
    }

    const autoLabelHasHigherPriority =
        clpViewState.selectedCLPLabel &&
        clpViewState.selectedCLPLabel.settingOrder < automaticLabel.settingOrder;

    return !clpViewState.selectedCLPLabel || autoLabelHasHigherPriority;
}

// When the following condition fits recommended label infobar should show.
// 1. When the automatic label exists
// 2. When there is no label manually set or the currently set label has lower encryption level than auto label.
export function shouldApplyRecommendedLabel(
    clpViewState: CLPViewState,
    recommendedLabel: CLPLabel
) {
    if (!recommendedLabel) {
        return false;
    }

    return (
        !clpViewState.selectedCLPLabel ||
        clpViewState.selectedCLPLabel.settingOrder < recommendedLabel.settingOrder
    );
}
